import { render, staticRenderFns } from "./workItem.vue?vue&type=template&id=4489f749&"
import script from "./workItem.vue?vue&type=script&lang=js&"
export * from "./workItem.vue?vue&type=script&lang=js&"
import style0 from "./workItem.vue?vue&type=style&index=0&scope=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports